import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxSituationCivile extends Component {

    static defaultProps = {
        label: "Situation actuelle",
        placeholder: "Situation actuelle",
    };

    componentDidUpdate = () => {
        // KP (10/03/2020) : cause demande de remplacement "Séparé" par "Divorcé"
        if (this.props.situationCivile === "Séparé")
            this.props.onChange({ key: "Divorcé" });
    }

    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const options = [
                { key: "Célibataire", text: "Célibataire" },
                { key: "Marié", text: "Marié" },
                { key: "Pacsé", text: "Pacsé" },
                { key: "Divorcé", text: "Divorcé" },
                { key: "Veuf", text: "Veuf" }
            ];
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
        />;

    };

};